import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/PageNotFound.css";
import pageNotFoundImage from "../../assets/images/page-not-found.png";
import appLogo from "../../assets/images/app-logo.svg";
import ROUTE_PATHS from "../../utils/routePaths";

const PageNotFound = () => {
    const navigate = useNavigate();

    const handleGoToDashboard = () => {
        navigate(ROUTE_PATHS.FBO_HOME);
    };

    return (
        <div className="page-not-found-container">
            <div className="page-not-found-header">
                <img src={appLogo} className="page-not-found-app-logo" alt="Airports Bahamas" />
            </div>
            <div className="page-not-found-content">
                <img
                    src={pageNotFoundImage}
                    alt="Page Not Found"
                    className="page-not-found-image"
                />
                <h1 className="page-not-found-title">Page Not Found</h1>
                <p className="page-not-found-message">
                    The page you are looking for might have been removed or had its name
                    changed.
                </p>
                <button
                    className="page-not-found-button"
                    onClick={handleGoToDashboard}
                >
                    Go to Dashboard
                </button>
            </div>
        </div>
    );
};

export default PageNotFound;
